<p>sku-item-stock-grid works!</p>
